<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="diadoc_is_load" parent="diadoc_document">
    <tab id="info" :name="translate('diadoc_document.section.info')" :href="url+'/info'">
      <DiadocInfo v-if="diadoc_is_load"
        :diadoc="diadoc_info"
        @update="request_diadoc"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Diadoc Document: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/diadoc/documents'}">
              To Diadoc Documents
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import DiadocInfo from './Tabs/Info/Info.vue'

export default {
  name: 'DiadocDocument',
  components: {
    DiadocInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      diadoc_info: null,
    }
  },

  computed: {
    url () { return '/diadoc_document/' + this.$route.params.diadoc_document_id },
    cur_id () { return this.$route.params.diadoc_document_id },
    load () { return !this.diadoc_info?.id },
    diadoc_is_load() { return this.diadoc_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'diadoc_section') {
        this.request_diadoc()
      }
    },
    diadoc_info(){
      if (this.$route.name === 'diadoc_document_section' && this.diadoc_info.file_name) {
        this.$store.commit('updateOtherTitle', this.diadoc_info.file_name)
      }
    }
  },

  activated(){
    this.request_diadoc()
  },

  destroyed() {
    this.diadoc_info = {}
  },

  methods: {
    request_diadoc () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_diadoc, 500)
    },
    get_diadoc () {
      this.$http.v1.getDiadocDocument(this.$route.params.diadoc_document_id, (response) => {
        this.diadoc_info = response.data
        // this.$store.commit('updateSelectedDiadoc', response.data)
      })
    }
  }
}

</script>
